module.exports = __webpack_public_path__ + "media/navigation/icon-log-out-2a46fc3e.svg";